<template>
  <div class="rate-wrapper">
    <Rate
      class="formily-switch"
      :disabled="disabled"
      v-model="model"
      :max="max"
    />
  </div>
</template>

<script>
import { Rate } from '@didi/rich-ui'
export default {
  components: { Rate },
  props: {
    disabled: false,
    value: {},
    max: {}
  },
  methods: {},
  computed: {
    model: {
      get () {
        return this.value
      },
      set (newVal) {
        this.$emit('input', newVal)
        this.$emit('change', newVal)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
